// source: starlord/messages/response/generic_response.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.GenericResponse', null, global);
goog.exportSymbol('proto.GenericResponse.status', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GenericResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GenericResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GenericResponse.displayName = 'proto.GenericResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GenericResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GenericResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GenericResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GenericResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requeststatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    responsemessage: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responsecode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    operationstatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GenericResponse}
 */
proto.GenericResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GenericResponse;
  return proto.GenericResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GenericResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GenericResponse}
 */
proto.GenericResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.GenericResponse.status} */ (reader.readEnum());
      msg.setRequeststatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponsemessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponsecode(value);
      break;
    case 4:
      var value = /** @type {!proto.GenericResponse.status} */ (reader.readEnum());
      msg.setOperationstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GenericResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GenericResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GenericResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GenericResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequeststatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResponsemessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponsecode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperationstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.GenericResponse.status = {
  SUCCESS: 0,
  FAILURE: 1
};

/**
 * optional status requestStatus = 1;
 * @return {!proto.GenericResponse.status}
 */
proto.GenericResponse.prototype.getRequeststatus = function() {
  return /** @type {!proto.GenericResponse.status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.GenericResponse.status} value
 * @return {!proto.GenericResponse} returns this
 */
proto.GenericResponse.prototype.setRequeststatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string responseMessage = 2;
 * @return {string}
 */
proto.GenericResponse.prototype.getResponsemessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.GenericResponse} returns this
 */
proto.GenericResponse.prototype.setResponsemessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string responseCode = 3;
 * @return {string}
 */
proto.GenericResponse.prototype.getResponsecode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.GenericResponse} returns this
 */
proto.GenericResponse.prototype.setResponsecode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional status operationStatus = 4;
 * @return {!proto.GenericResponse.status}
 */
proto.GenericResponse.prototype.getOperationstatus = function() {
  return /** @type {!proto.GenericResponse.status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.GenericResponse.status} value
 * @return {!proto.GenericResponse} returns this
 */
proto.GenericResponse.prototype.setOperationstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


goog.object.extend(exports, proto);
